import _createForOfIteratorHelper from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import { reactive, ref } from "vue";
export default {
  name: "KilaKilaCatalog",
  setup: function setup(props) {
    var titles = reactive(getTitles());
    var currentTitle = reactive({});
    var progress = ref(0); // 获取目录的标题

    function getTitles() {
      var titles = [];
      var levels = ["h1", "h2", "h3"];
      var articleElement = document.querySelector(props.container);

      if (!articleElement) {
        return titles;
      }

      var elements = Array.from(articleElement.querySelectorAll("*")); // 调整标签等级

      var tagNames = new Set(elements.map(function (el) {
        return el.tagName.toLowerCase();
      }));

      for (var i = levels.length - 1; i >= 0; i--) {
        if (!tagNames.has(levels[i])) {
          levels.splice(i, 1);
        }
      }

      var serialNumbers = levels.map(function () {
        return 0;
      });

      for (var _i = 0; _i < elements.length; _i++) {
        var element = elements[_i];
        var tagName = element.tagName.toLowerCase();
        var level = levels.indexOf(tagName);
        if (level == -1) continue;
        var id = tagName + "-" + element.innerText + "-" + _i;
        var node = {
          id: id,
          level: level,
          parent: null,
          children: [],
          rawName: element.innerText,
          scrollTop: element.offsetTop
        };

        if (titles.length > 0) {
          var lastNode = titles.at(-1); // 遇到子标题

          if (lastNode.level < node.level) {
            node.parent = lastNode;
            lastNode.children.push(node);
          } // 遇到上一级标题
          else if (lastNode.level > node.level) {
            serialNumbers.fill(0, level + 1);
            var parent = lastNode.parent;

            while (parent) {
              if (parent.level < node.level) {
                parent.children.push(node);
                node.parent = parent;
                break;
              }

              parent = parent.parent;
            }
          } // 遇到平级
          else if (lastNode.parent) {
            node.parent = lastNode.parent;
            lastNode.parent.children.push(node);
          }
        }

        serialNumbers[level] += 1;
        var serialNumber = serialNumbers.slice(0, level + 1).join(".");
        node.isVisible = node.parent == null;
        node.name = serialNumber + ". " + element.innerText;
        titles.push(node);
      }

      return titles;
    } // 监听滚动事件并更新样式


    window.addEventListener("scroll", function () {
      progress.value = parseInt(window.scrollY / document.documentElement.scrollHeight * 100) + "%";
      var visibleTitles = [];

      for (var i = titles.length - 1; i >= 0; i--) {
        var title = titles[i];

        if (title.scrollTop <= window.scrollY) {
          if (currentTitle.id === title.id) return;
          Object.assign(currentTitle, title); // 展开节点

          setChildrenVisible(title, true);
          visibleTitles.push(title); // 展开父节点

          var parent = title.parent;

          while (parent) {
            setChildrenVisible(parent, true);
            visibleTitles.push(parent);
            parent = parent.parent;
          } // 折叠其余节点


          var _iterator = _createForOfIteratorHelper(titles),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var t = _step.value;

              if (!visibleTitles.includes(t)) {
                setChildrenVisible(t, false);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return;
        }
      }
    }); // 设置子节点的可见性

    function setChildrenVisible(title, isVisible) {
      var _iterator2 = _createForOfIteratorHelper(title.children),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          child.isVisible = isVisible;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } // 滚动到指定的位置


    function scrollToView(scrollTop) {
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth"
      });
    }

    return {
      titles: titles,
      currentTitle: currentTitle,
      progress: progress,
      scrollToView: scrollToView
    };
  },
  props: {
    container: {
      type: String,
      default: ".post-body .article-content"
    }
  }
};